import firebase from 'firebase/compat/app'
import 'firebase/compat/auth'
import 'firebase/compat/firestore'
import 'firebase/compat/functions'
import { initPerf } from './components/providers/PerfProvider'
import { config } from './config'
import { firebaseEmulatorConfig, isUseFirebaseEmulators } from './shared-config'

const app = firebase.initializeApp(config)
const auth = app.auth()
const firestore = app.firestore()
const functions = app.functions()

if (isUseFirebaseEmulators) {
  // auth.useEmulator(firebaseEmulatorConfig.uris.auth)
  // connectAuthEmulator(getAuth(), firebaseEmulatorConfig.uris.auth)

  // firestore.useEmulator(firebaseEmulatorConfig.host, firebaseEmulatorConfig.ports.firestore)
  // connectFirestoreEmulator(getFirestore(), firebaseEmulatorConfig.host, firebaseEmulatorConfig.ports.firestore)

  functions.useEmulator(firebaseEmulatorConfig.host, firebaseEmulatorConfig.ports.functions)
}

initPerf()
